// extracted by mini-css-extract-plugin
export default {"modalBody":"XBlxWflFovXnYqX1_vYI","header1":"KZhN1LSkjq600ps3oVWw","header2":"RhBsPXhHuN_g1ZJdeTuL"};